var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{staticClass:"form-group"},[_c('Search',{attrs:{"id":"search"}}),_c('b-form-input',{staticClass:"patient-search-input",attrs:{"autocomplete":"off","debounce":"500","placeholder":"Buscar por Paciente"},model:{value:(_vm.value.name),callback:function ($$v) {_vm.$set(_vm.value, "name", $$v)},expression:"value.name"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }